import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Address, Customer, HonorificPrefix, MarketingConsent } from '../../services/kingfisher/customer';
import { Country, otherCountries, prioCountries } from '../../services/kingfisher/countries';
import { MemberTypeCh } from '../../services/fidelity/fidelity';

export type FidelityInfo = {
  premium?: boolean;
  memberType?: MemberTypeCh;
  siret?: string;
  nTvaIntracommunautaire?: string;
};
export type CustomerInfo = {
  customer?: Customer;
  address?: Address;
  marketingConsent?: MarketingConsent;
  fidelity?: FidelityInfo;
};

export function BuildMarketingConsentFormGroup(defaultValue?: MarketingConsent): FormGroup {
  return new FormGroup({
    email: new FormControl<boolean>(defaultValue?.email ?? false),
    phone: new FormControl<boolean>(defaultValue?.phone ?? false),
    post: new FormControl<boolean>(defaultValue?.post ?? false),
    sms: new FormControl<boolean>(defaultValue?.sms ?? false),
  });
}

export function BuildCustomerAddressFormGroup(defaultValue?: Address): FormGroup {
  const countries: Country[] = [].concat(prioCountries, otherCountries);
  return new FormGroup({
    num: new FormControl<string | null>(defaultValue?.num),
    line1: new FormControl<string | null>(defaultValue?.line1),
    line2: new FormControl<string | null>(defaultValue?.line2),
    postalCode: new FormControl<string | null>(defaultValue?.postalCode),
    city: new FormControl<string | null>(defaultValue?.city),
    complement: new FormControl<string | null>(defaultValue?.complement),
    country: new FormControl<Country | null>(countries?.find(x => x.value === defaultValue?.country)),
  });
}

export function BuildCustomerCivilityFormGroup(defaultValue?: Customer): FormGroup {
  return new FormGroup({
    civility: new FormControl<HonorificPrefix | null>(
      defaultValue?.honorificPrefix as HonorificPrefix,
      Validators.required
    ),
    firstname: new FormControl<string | null>(defaultValue?.firstname, Validators.required),
    lastname: new FormControl<string | null>(defaultValue?.lastname, Validators.required),
    email: new FormControl<string | null>(defaultValue?.email, Validators.required),
    mobile: new FormControl<string | null>(defaultValue?.phoneNumber, Validators.required),
    birthdate: new FormControl<Date | null>(defaultValue?.dateOfBirth ? new Date(defaultValue.dateOfBirth) : null),
  });
}

export function BuildFidelityFormGroup(defaultValue?: FidelityInfo) {
  return new FormGroup({
    premium: new FormControl<boolean>(defaultValue?.premium ?? undefined),
    memberType: new FormControl<MemberTypeCh>(defaultValue?.memberType ?? undefined),
    siret: new FormControl<string>(defaultValue?.siret),
    nTvaIntracommunautaire: new FormControl<string>(defaultValue?.nTvaIntracommunautaire),
  });
}

export function BuildCustomerInfoFormGroup(input: {
  civilityFormGroup: FormGroup;
  addressFormGroup: FormGroup;
  marketingConsentFormGroup: FormGroup;
  fidelityFormGroup?: FormGroup;
}): FormGroup {
  return new FormGroup({
    civility: input.civilityFormGroup,
    address: input.addressFormGroup,
    marketingConsent: input.marketingConsentFormGroup,
    fidelity: input.fidelityFormGroup ?? new FormGroup({}),
  });
}
